const SELECT = 'select'
const INPUT = 'input'

module.exports = {
  SELECT,
  INPUT,
}
